import { createElement } from 'react';
import { colors } from '@lamimed/pantheon';
import { LucideIcon } from 'lucide-react';
import { useRouter } from 'next/router';

import * as S from './styles';

export interface Bar {
  href: string;
  content: string;
  icon: LucideIcon;
  notificationCount?: number;
}

interface Props {
  tabs: Array<Bar>;
}

export function TabBar({ tabs }: Props) {
  const { asPath } = useRouter();

  return (
    <S.Container>
      {tabs.map(({ content, href, icon, notificationCount }, idx) => (
        <S.Item key={idx} href={href}>
          <S.Icon>
            {createElement(icon, {
              size: 18,
              color: colors.dark,
              strokeWidth: 1,
            })}
          </S.Icon>

          <S.SmallTypography marginBottom="none">{content}</S.SmallTypography>

          {!!notificationCount && (
            <S.NotificationContainer>
              <S.SmallTypography
                fontWeight="bold"
                marginBottom="none"
                color="text__light"
                lineHeight="none"
              >
                {notificationCount}
              </S.SmallTypography>
            </S.NotificationContainer>
          )}

          <S.Outline active={asPath === href} />
        </S.Item>
      ))}
    </S.Container>
  );
}
